import { Routes, Route, Navigate } from 'react-router-dom';
import { ClassProvider } from '../components/classContext';
import ClassList from './ClassList/Pages';
import ClassManagementTabs from './ClassManagement/Pages/index';
import ClassManagement from './ClassManagement/Pages/classManagement';
import SessionsAndReport from './SessionsAndReport/Pages/sessionsAndReport';
import MathSkill from './SessionsAndReport/Pages/mathSkill';
import Index from './SessionsAndReport/Pages/index';
import AcessRights from './ClassManagement/Pages/accessRights';
import { DashboardProvider } from '../../dashboard/context';
import { ClassManagementProvider } from './ClassManagement/utils/classManagementContext';
import MathSkillReport from './SessionsAndReport/Pages/mathSkillReport';
import IdCards from './ClassManagement/Pages/idCards';
import AddStudents from './ClassManagement/Pages/addStudents';
import ViewSessions from './SessionsAndReport/Pages/ViewSessions';
import ClassCumulativeReport from '../../assignments/pages/ManageAssign/components/Reports/ClassCumulativeReport';
import StudentCumulativeReport from '../../assignments/pages/ManageAssign/components/Reports/StudentCumulativeReport';
import { ReportProvider } from '../../reports/components/reportContext';

const classRoute = () => {
  return (
    <div>
      <ClassManagementProvider>
        <Routes>
          <Route path="/" element={
            <ClassProvider>
              <ClassList />
            </ClassProvider>
          } >
          </Route>
          <Route path=":Id/classManagement/" element={<ClassManagementTabs />}>
            <Route index element={<Navigate to="classManagement" />} />
            <Route path="classManagement" element={<DashboardProvider><ClassProvider><ClassManagement /></ClassProvider></DashboardProvider>} />
            <Route path="acessRights" element={<ClassProvider><AcessRights /></ClassProvider>} />
          </Route>
          <Route path=":Id/classManagement/classManagement/idCards" element={<IdCards />} />
          <Route path=":Id/classManagement/classManagement/addStudents" element={<AddStudents />} />
          <Route path=":Id/:courseId/classCumulativeReport" element={<ReportProvider><ClassCumulativeReport /></ReportProvider>} />
          <Route path=":Id/:courseId/:studentId/studentCumulativeReport" element={<ReportProvider><StudentCumulativeReport /></ReportProvider>} />
          <Route path=":Id/classSessionsAndReport/*" element={<Index />}>
            <Route index element={<Navigate to="sessionsAndReport" />} />
            <Route path="sessionsAndReport" element={<SessionsAndReport />} />
            <Route path="mathSkills/*" element={<MathSkill />} />
          </Route>
          <Route path=":Id/:studentId/:courseId/viewSessions" element={<ViewSessions />} />
          <Route path=":Id/classSessionsAndReport/mathSkills/:courseId/:studentId/skillReport" element={<MathSkillReport />} />
        </Routes>
      </ClassManagementProvider>
    </div>
  );
};

export default classRoute;